rjm.ui.ChartBuilderCohortMemberSelectorView = Backbone.View.extend(
  id: "cbCohortMember"
  className: "span"

  events:
    "click button": "toggleMemberTable"

  initialize: (options) ->
    if not options or not options.chartModel
      throw "InvalidConstructorArgs - ChartBuilderCohortFieldView"

    _.bindAll this, "generateTemplateData", "render"

    @chartModel = options.chartModel
    @cohortDescriptor = @chartModel.getCurrentSeries().get('cohortDescriptor')
    @cohortField = @cohortDescriptor.get("cohortField") #initalizing to null

    @listenTo @cohortDescriptor, "change:cohortField", (cohortDescriptor, options) =>
      @cohortField = cohortDescriptor.get("cohortField")
      @render()

    return

  toggleMemberTable: (e) ->
    e?.preventDefault()
    if @$(e.target).attr("id") is "local"
      @cohortDescriptor.set
        useRemoteMemberCount: false
    if @$(e.target).attr("id") is "remote"
      @cohortDescriptor.set
        useRemoteMemberCount: true

  generateTemplateData: (data) ->
    localTableName: if @cohortField? then @capatalizeFirstLetter(@cohortField.get("localTableName"))
    remoteTableName: if @cohortField? then @capatalizeFirstLetter(@cohortField.get("remoteTableName"))
    useRemoteTable: @cohortDescriptor.get("useRemoteMemberCount")

  capatalizeFirstLetter: (string) ->
    return string.charAt(0).toUpperCase() + string.slice(1);

  render: ->
    if @cohortField?.hasMembers()
      @$el.show()
    else
      @$el.hide()
      return
    @$el.html ich.chartBuilderCohortMemberSelector(@generateTemplateData())

    return @
)
